import { render, staticRenderFns } from "./RegBaseHeaderSec.vue?vue&type=template&id=2ecc3b04&scoped=true&"
import script from "./RegBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./RegBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc3b04",
  null
  
)

export default component.exports